import { IMedia, IPlayerMedia } from "models/media.model";
import DOMPurify from "dompurify";
import { cleanUrlParams, getExtensionFromUrl, getMimeTypeFromExtension } from "helpers/mime-type.helper";

export function FormattedMediaForPlayer(media: IMedia[], params: Record<string, any>): IPlayerMedia[] {

  const paramsStr = Object.keys(params)
    .map((key: string) => {
      return "" + key + "=" + params[key];
    })
    .join("&");

  const hasParams = (source: string): boolean => {
    // @ts-ignore
    return [...new URL(source).searchParams].length > 0
  }


  return media.map((media: IMedia) => {
    return {
      description: DOMPurify.sanitize(media.description as string, {ALLOWED_TAGS: []}),
      sources: [
        {
          src: `${media.source}${
            paramsStr !== "" ? `${hasParams(media.source) ? '&' : '?'}${paramsStr}` : ""
          }`,
          type: getMimeTypeFromExtension(getExtensionFromUrl(cleanUrlParams(media.source))),
        },
      ],
      title: DOMPurify.sanitize(media.title, {ALLOWED_TAGS: []}),
      thumb: media.thumbnails?.image ?? "",
      duration: new Date(Number(media.duration) * 1000)
        .toISOString()
        .slice(11, 19),
      subtitles: media.subtitles || [],
      chapters: media.chapters ? {
        url: media.chapters,
        mimetype: getMimeTypeFromExtension(getExtensionFromUrl(media?.chapters)),
      } : null,
      timeline: {
        url: media.thumbnails?.timeline ?? '',
        mimetype: getMimeTypeFromExtension(getExtensionFromUrl(cleanUrlParams(media.thumbnails?.timeline))),
      },
    };
  });
}
